import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { topicMessagesApi } from '../api/topicMessages';

export function useStudentTopicThread(topicId: string, enabled: boolean) {
  return useQuery({
    queryKey: ['topic-messages', 'student', topicId],
    queryFn: () => topicMessagesApi.studentThread(topicId),
    enabled,
    refetchInterval: 15_000,
  });
}

export function useTrainerTopicThread(topicId: string, studentId: string, enabled: boolean) {
  return useQuery({
    queryKey: ['topic-messages', 'trainer', topicId, studentId],
    queryFn: () => topicMessagesApi.trainerThread(topicId, studentId),
    enabled,
    refetchInterval: 15_000,
  });
}

export function useTrainerQuestionInbox(enabled: boolean) {
  return useQuery({
    queryKey: ['topic-messages', 'inbox'],
    queryFn: topicMessagesApi.inbox,
    enabled,
    refetchInterval: 30_000,
  });
}

export function useSendTopicMessage(invalidateKey: unknown[]) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: topicMessagesApi.send,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: invalidateKey });
      qc.invalidateQueries({ queryKey: ['topic-messages', 'inbox'] });
    },
  });
}
